import { API_BASE_URL } from '../config';

export const registerPushToken = async (userId) => {
    if (!userId) return;

    // In a real environment with Firebase, you would do:
    // const token = await getToken(messaging, { vapidKey: 'YOUR_VAPID_KEY' });
    
    // For this implementation, we will simulate or use a mock token 
    // to demonstrate the flow until Firebase is fully configured by the user.
    let token = localStorage.getItem('fcm_token');
    
    if (!token) {
        token = 'mock_token_' + Math.random().toString(36).substring(7);
        localStorage.setItem('fcm_token', token);
    }

    try {
        const response = await fetch(`${API_BASE_URL}save_push_token.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId, token })
        });
        const data = await response.json();
        console.log('Push token registration:', data.message);
    } catch (error) {
        console.error('Failed to register push token:', error);
    }
};

export const requestNotificationPermission = async (userId) => {
    if (!("Notification" in window)) {
        console.log("This browser does not support desktop notification");
        return;
    }

    if (Notification.permission === "granted") {
        registerPushToken(userId);
    } else if (Notification.permission !== "denied") {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            registerPushToken(userId);
        }
    }
};
